// extracted by mini-css-extract-plugin
export default {"container":"user_container__d5g0H","details":"user_details__TF6Zh"};